import { blockBody, unBlockBody } from '../../../utils/utils';
import './Popup.scss';

export default class Popup {
	constructor() {
		this.closeButtons = [];
		this.currentPopup = null;
		this.init();
	}

	init() {
		document.addEventListener('keydown', this.closingByEsc.bind(this));
	}

	showPopup(popupId) {
		const popup = document.getElementById(popupId);
		if (!popup) {
			console.error(`Popup with ID "${popupId}" not found.`);
			return;
		}

		// Save the current popup reference
		this.currentPopup = popup;
		this.closeButtons = popup.querySelectorAll('.js-popup-close');

		// Add event listeners to close buttons
		this.closeButtons.forEach((button) => {
			button.addEventListener('click', this.closePopup.bind(this));
		});

		// Show the popup
		blockBody();
		popup.classList.add('is-active');

		// Add event listener for closing by dark area
		popup.addEventListener('click', this.closingByDarkArea.bind(this));
	}

	closePopup() {
		if (!this.currentPopup) return;

		// Remove active class and cleanup event listeners
		unBlockBody();
		this.currentPopup.classList.remove('is-active');

		this.closeButtons.forEach((button) => {
			button.removeEventListener('click', this.closePopup.bind(this));
		});
		this.currentPopup.removeEventListener('click', this.closingByDarkArea.bind(this));

		// Reset current popup reference
		this.currentPopup = null;
		this.closeButtons = [];
	}

	reloadPage() {
		location.reload();
	}

	closingByDarkArea(e) {
		if (!e.target.closest('.js-popup-content')) {
			this.closePopup();
		}
	}

	closingByEsc(e) {
		if (e.keyCode === 27) {
			this.closePopup();
		}
	}
}
